<template>
  <div style="width: 100%" ref="dom"></div>
</template>

<script>
import echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Object,
    text: String,
  },
  data() {
    return {
      dom: null,
      title: "出货量",
      option: {
        title: {
          text: "出货量",
          x: "center",
        },
        toolbox: {
          feature: {
            saveAsImage: {
              title: this.$t("download"),
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter:
            "{b0}<br/>{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}%<br />",
        },
        legend: {
          data: [
            this.$t("shipment_all"),
            this.$t("SignedAmount"),
            this.$t("ReceiptRate"),
          ],
          bottom: 0,
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.$t("shipment_all") + "/" + this.$t("SignedAmount"),
            min: 0,
            max: 10000,
            interval: 1000,
            axisLabel: {
              formatter: "{value} 件",
            },
          },
          {
            type: "value",
            name: this.$t("ReceiptRate"),
            boundaryGap: ["0%", "100%"],
            min: 0,
            max: 100,
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value}%",
            },
            show: true,
          },
        ],
        series: [
          {
            name: this.$t("shipment_all"),
            type: "bar",
            data: [],
            label: {
              show: true,
              position: "top",
            },
          },
          {
            name: this.$t("SignedAmount"),
            type: "bar",
            data: [],
            label: {
              show: true,
              position: "top",
            },
          },
          {
            name: this.$t("ReceiptRate"),
            type: "line",
            yAxisIndex: 1,
            data: [],
            // markLine: {
            //   data: [
            //     {
            //       // type: "average",
            //       yAxis: 1,
            //       name: "Avg"
            //     }
            //   ]
            // },
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
            },
          },
        ],
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        this.setOpt();
      },
      deep: true,
    },
  },
  methods: {
    resize() {
      this.dom.resize();
    },
    setOpt() {
      if (this.value.report_date && this.value.report_date.length) {
        this.option.title.text =
          this.value.report_date[0] +
          "~" +
          this.value.report_date[this.value.report_date.length - 1] +
          this.$t("shipment_all");
      } else {
        this.option.title.text = this.$t("shipment_all");
      }
      this.option.xAxis[0].data = this.value.report_date;
      this.option.series[0].data = this.value.order_count;
      this.option.series[1].data = this.value.pod_count;
      this.option.series[2].data = this.value.receiptRate;
      this.option.series[0].markLine = {
        data: [{ yAxis: this.value.average, name: "Avg" }],
      };
      this.$nextTick(() => {
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(this.option, true);
        on(window, "resize", this.resize);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.dom = echarts.init(this.$refs.dom, "tdTheme");
      this.dom.setOption(this.option, true);
      on(window, "resize", this.resize);
    });
    if (this.value && this.value.rows) {
      this.setOpt();
    }
  },
  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
